<template>
  <div v-if="error" class="input-row--error-text">
    <IconError />
    {{ error }}
  </div>
</template>

<script setup lang="ts">
import IconError from '@/icons/IconError.svg?component'

defineProps<{
  error: string;
}>();
</script>

<style lang="scss">
.input-row--error-text {
  @include mixins.flex-center($horiz: flex-start, $gap: variables.$sizing-xxs);
  @include typography.font-caption();
  color: variables.$primitives-color-red-300;

  > svg {
    flex-shrink: 0;
  }
}

.input-error-text {
  @include typography.font-caption();
  color: variables.$primitives-color-red-100;
  margin-top: variables.$sizing-xxxs;
}

</style>